module.exports = __webpack_public_path__ + "static/media/D2.6e251cff.png";